import { Route } from '@angular/router';
import { GameMode } from '@dc-core/dc-backend/dc-enums';
import { adminGuard } from 'src/app/modules/authentication/guards/admin.guard';
import { gamesLocalLeaveBusterGuard } from 'src/app/modules/games/guards/games-local-leave-buster.guard';
import { gamesTrialGuard } from 'src/app/modules/games/guards/games-trial.guard';

import { GameModeThemeRouteData } from '../../themes/game-mode.theme';

export const bullseyeSummitLocalGameRoutes: Route[] = [
    {
        path: 'local-games/bullseye-summit',
        data: { gameModeTheme: 'bullseyesummit' } satisfies GameModeThemeRouteData,
        canActivate: [adminGuard],
        loadComponent: () =>
            import('./pages/bullseye-summit-new-game/bullseye-summit-new-game.component').then(
                (c) => c.BullseyeSummitNewGameComponent
            ),
    },
    {
        path: 'game/bullseye-summit',
        data: {
            gameMode: 'bullseye_summit' as GameMode,
            gameModeTheme: 'bullseyesummit',
        } satisfies GameModeThemeRouteData,
        canActivate: [adminGuard, gamesTrialGuard],
        canDeactivate: [gamesLocalLeaveBusterGuard],
        loadComponent: () =>
            import('./pages/bullseye-summit-local-game/bullseye-summit-local-game.component').then(
                (c) => c.BullseyeSummitLocalGameComponent
            ),
    },
];
